import React from "react";
import "./css/Kapasite.css";


const Kapasite = () => {

  

  return (
    <div className="baslik p-md-5 p-3 pt-0 pb-0">
        <div className="d-flex flex-row justify-content-center header_1">
            <div className="each_header d-flex flex-column justify-content-end ">
                <label className="kapasite_label">Facility Capacity</label>
                <label className="kapasite_band" style={{ zIndex: 1 }}>36.000 Tone</label>
            </div>
            <div className="each_header d-flex flex-column  justify-content-end ">
                <label className="kapasite_label">Factory Area</label>
                <label className="kapasite_band" style={{ zIndex: 2 }}>7.000 m2</label>
            </div>
            <div className="each_header d-flex flex-column justify-content-end ">
                <label className="kapasite_label">Export</label>
                <label className="kapasite_band" style={{ zIndex: 3 }}>10 Country</label>
            </div>
            <div className="each_header d-flex flex-column justify-content-end ">
                <label className="kapasite_label">Number of Employees</label>
                <label className="kapasite_band" style={{ zIndex: 4 }}>110</label>
            </div>
        </div>
    </div>
  );
};

export default Kapasite;
